module.exports = __webpack_public_path__ + "media/video.97ebf5ef.mp4";